import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Theme from '../Theme';
var palette = Theme.palette;
/**
 * Logo
 *
 * See README, run storybook or see propTypes below for documentation
 *
 * @return {jsx}
 */

var Logo = function Logo(_ref) {
  var color = _ref.color,
      height = _ref.height,
      width = _ref.width;

  /**
   * Get color
   *
   * @return {string}
   */
  var getColor = useMemo(function () {
    if (palette.hasOwnProperty(color)) return palette[color];
    return color;
  }, [color]);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    width: width,
    height: height,
    viewBox: "0 0 116 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: getColor,
    d: "M15.645 28.166c6.571 0 11.897-5.447 11.897-12.166 0-6.72-5.326-12.167-11.897-12.167C9.075 3.833 3.75 9.281 3.75 16c0 6.72 5.326 12.166 11.896 12.166zm15.218-12.604c.235 0 .428.197.428.438a.435.435 0 0 1-.428.438h-2.08a13.549 13.549 0 0 1-3.544 8.753l1.47 1.503c.166.17.166.45 0 .62a.424.424 0 0 1-.607 0l-1.469-1.503c-2.254 2.16-5.252 3.516-8.559 3.625v2.126a.435.435 0 0 1-.429.438.435.435 0 0 1-.428-.438v-2.126c-3.308-.109-6.305-1.464-8.56-3.625l-1.469 1.503a.424.424 0 0 1-.606 0 .447.447 0 0 1 0-.62l1.47-1.503a13.551 13.551 0 0 1-3.545-8.753H.428A.435.435 0 0 1 0 16c0-.241.193-.438.428-.438h2.079a13.553 13.553 0 0 1 3.545-8.754l-1.47-1.502a.447.447 0 0 1 0-.62c.167-.17.44-.17.606 0l1.47 1.503c2.254-2.16 5.251-3.517 8.559-3.625V.438c0-.24.193-.438.428-.438.236 0 .43.197.43.438v2.126c3.306.108 6.304 1.464 8.558 3.625l1.47-1.503c.166-.17.439-.17.605 0 .167.17.167.45 0 .62L25.24 6.808a13.55 13.55 0 0 1 3.545 8.754h2.079zM15.646 6.024C21.024 6.024 25.4 10.5 25.4 16a9.8 9.8 0 0 1-.011.464.532.532 0 0 1-.187.383.504.504 0 0 1-.401.117 1.1 1.1 0 0 0-1.097.53 1.152 1.152 0 0 0 .364 1.562c.074.046.155.083.246.113a.522.522 0 0 1 .314.283c.06.136.063.29.007.429a10.062 10.062 0 0 1-1.011 1.855.511.511 0 0 1-.756.101 1.083 1.083 0 0 0-.972-.237c-.288.07-.533.251-.687.51-.25.414-.213.943.091 1.318a.537.537 0 0 1-.103.774 9.728 9.728 0 0 1-1.687.959.507.507 0 0 1-.422-.005.526.526 0 0 1-.278-.324 1.13 1.13 0 0 0-.477-.628 1.084 1.084 0 0 0-.839-.137c-.288.07-.532.252-.688.51-.138.23-.191.504-.15.772a.54.54 0 0 1-.108.416.517.517 0 0 1-.376.196c-.174.01-.35.015-.526.015-5.38 0-9.755-4.475-9.755-9.976 0-5.501 4.376-9.976 9.755-9.976zm7.402 14.685c.156-.255.299-.517.427-.783-.968-.647-1.263-1.973-.654-2.986.119-.198.266-.37.433-.515h-2.447c-.202 2.584-2.217 4.645-4.745 4.851v2.544a2.123 2.123 0 0 1 1.192-.783 2.09 2.09 0 0 1 1.622.264c.272.172.5.402.673.672.22-.113.437-.237.648-.37a2.235 2.235 0 0 1 .129-2.048c.3-.5.772-.85 1.33-.985a2.081 2.081 0 0 1 1.392.139zm-16.11-4.284a8.985 8.985 0 0 0 2.258 5.568l2.506-2.562a5.334 5.334 0 0 1-1.218-3.005H7.196l-.003-.001h-.256zm2.259-6.42a8.985 8.985 0 0 0-2.26 5.569h3.547a5.335 5.335 0 0 1 1.217-3.006L9.377 10.19l-.003-.004-.177-.182zM15.23 7.37v-.275a8.588 8.588 0 0 0-5.445 2.31l2.505 2.56a5.097 5.097 0 0 1 2.94-1.244V7.372v-.003zm3.772 4.597l2.504-2.561a8.586 8.586 0 0 0-5.444-2.31v3.625a5.096 5.096 0 0 1 2.94 1.246zm-3.356 8.031c2.16 0 3.91-1.79 3.91-3.999s-1.75-3.999-3.91-3.999-3.911 1.79-3.911 3.999 1.75 4 3.91 4zm-3.355.035l-2.506 2.563a8.587 8.587 0 0 0 5.445 2.31v-3.628a5.096 5.096 0 0 1-2.94-1.245zm8.516-4.458h3.546a8.988 8.988 0 0 0-2.259-5.567l-2.504 2.56a5.336 5.336 0 0 1 1.217 3.007zm60.21-3.735v8.383H87.5v1.185H79.86v-9.568h1.156zm-13.425 0v8.383h6.484v1.185h-7.64v-9.568h1.156zm-27.833 0h8.615v1.185h-3.728v8.383h-1.158v-8.383H39.76v-1.185zm68.688 5.412h-.025v4.156h-1.159v-9.568h5.884v-.004c1.448 0 2.623 1.197 2.623 2.68 0 1.48-1.175 2.682-2.623 2.682h-.337l3.139 4.21h-1.49l-3.104-4.21-2.908.054zm-.025-4.227v3.006l4.725-.017c.854 0 1.538-.731 1.462-1.624-.066-.784-.75-1.365-1.52-1.365h-4.667zm-51.966 8.383v-9.568h1.158v9.568h-1.158zm36.828-9.568h7.64v1.185h-6.481v3.006h4.128v1.183h-4.128v3.009h6.48v1.185h-7.639v-9.568z",
    "data-testid": "logoPath"
  }));
};
/**
 * PropTypes Validation
 */


var string = PropTypes.string;
Logo.propTypes = {
  /**
   * Fill color
   */
  color: string,

  /**
   * The logo height
   */
  height: string,

  /**
   * The logo width
   */
  width: string
};
/**
 * Default props
 */

Logo.defaultProps = {
  color: 'white',
  height: '59',
  width: '180'
};
export default Logo;